export default function strToUrl(str: string) {
  let converted = str
    .normalize("NFKD")
    .replace(/\s+/g, "_")
    .replace(/[^\w\s.-_/]/g, "")
    .toLowerCase()
  return converted
}
